import { Controller } from "@hotwired/stimulus"

// 이웃 뉴스레터(Beta) 영역이 화면에 절반 이상 들어오면 노출 신호를 한 번 보낸다.
// 글 페이지는 캐시된 HTML 이라 서버에서 그릴 때 셀 수 없어서 브라우저가 알려준다 (Spaces::NeighborImpressionsController).
export default class extends Controller {
  static values = { url: String, ids: Array }

  connect() {
    if (!this.urlValue || this.idsValue.length === 0 || !("IntersectionObserver" in window)) return

    this.observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        this.send()
        this.disconnect()
      }
    }, { threshold: 0.5 })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
    this.observer = null
  }

  send() {
    const body = new FormData()
    this.idsValue.forEach((id) => body.append("ids[]", id))

    if (navigator.sendBeacon) {
      navigator.sendBeacon(this.urlValue, body)
    } else {
      fetch(this.urlValue, { method: "POST", body, keepalive: true, credentials: "same-origin" }).catch(() => {})
    }
  }
}
